export default __webpack_public_path__ + "static/media/RevArr.7f0f2f29.gif";